import React from 'react';
import CareMapprButton from '../../components/Button/CareMapprButton';
import { useLegalContent, type LegalTenancyKey } from './LegalContentContext';

interface LegalTenancySelectionProps {
  onSelect: (tenancyKey: LegalTenancyKey) => void;
  isTermsActive: boolean;
}

const LegalTenancySelection = ({
  onSelect,
  isTermsActive,
}: LegalTenancySelectionProps) => {
  const { tenancyButtons } = useLegalContent();
  const titleText = isTermsActive ? 'Terms of Service' : 'Privacy Policy';
  const descriptionText = titleText.toLocaleLowerCase();
  return (
    <div className="legal-tenancy-selection">
      <h2 className="text-center">CareMappr {titleText}</h2>
      <div className="text-center">
        Select your tenancy for your specific {descriptionText}
      </div>
      <div className="d-flex flex-column justify-content-center align-items-center gap-2">
        {tenancyButtons.map((btn) => (
          <CareMapprButton
            key={btn.key}
            variant={btn.variant || 'primary'}
            onClick={() => onSelect(btn.key)}
          >
            {btn.label}
          </CareMapprButton>
        ))}
      </div>
    </div>
  );
};

export default LegalTenancySelection;
